import { YesNoIndicators } from '../../../../global/models/api-model';

export interface Document {
	id: string,
	name: string,
	contentURL: string,
}

export interface ProductSummary {
	product_categories: {
		dental: YesNoIndicators,
		group_life: YesNoIndicators,
		long_term_disability: YesNoIndicators,
		medical: YesNoIndicators,
		short_term_disability: YesNoIndicators,
		supplemental_life: YesNoIndicators,
		supplemental_spouse: YesNoIndicators,
		unemployment_insurance: YesNoIndicators,
	}

}

export interface DocumentDownloadState {
	documents: Document[] | string,
	documentsLoaded: boolean,
	requesting: boolean,
	productSummary?: ProductSummary,
	groupLifeContractList?: any,
	groupLifeContractListLoaded?: boolean,
}

export enum DocumentDownloadActions {
	SET_DOCUMENTS = 'SET_DOCUMENTS',
	GET_DOCUMENTS = 'GET_DOCUMENTS',
	SET_PRODUCT_SUMMARY = 'SET_PRODUCT_SUMMARY',
	SET_GROUP_LIFE_CONTRACT_LIST = 'SET_GROUP_LIFE_CONTRACT_LIST',
}